// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1fDnH","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1TcQc","obliqueLine":"membershipbadge_obliqueLine__1BStq"};